document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.recommended-carousel');
  
    carousels.forEach(carousel => {
      const leftButton = carousel.previousElementSibling;
      const rightButton = carousel.nextElementSibling;
  
      // Scroll Buttons
      leftButton.addEventListener('click', function() {
        carousel.scrollBy({ left: -300, behavior: 'smooth' });
      });
  
      rightButton.addEventListener('click', function() {
        carousel.scrollBy({ left: 300, behavior: 'smooth' });
      });
  
    
    
    });
  });
  